import { gql } from "apollo-boost";

export const PreloadStatus = gql`
    fragment PreloadStatus on PreloadStatus {
        status
        progress
        timestamp
        desc
    }
`;

export const Preloader = {
    Preload: gql`
        mutation preload($patientCaseInput: [GroupedFeature], $diseasesInput: [QualifiedFeatureInput], $commitSerial: Float, $desc:String) {
            preload(patientCaseInput: {findings :$patientCaseInput}, diseasesInput: $diseasesInput, commitSerial: $commitSerial, desc: $desc)
        }
    `,
    PreloadStatus: gql`
        query preloadStatus($id: String) {
            preloadStatus(id: $id) {...PreloadStatus }
        }
        ${PreloadStatus}
    `,
    PreloadJobs: gql`
        query allJobs { allJobs {...PreloadStatus}}
        ${PreloadStatus}
    `
}
